// src/admin/AppAdmin.jsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import QueueAdmin from './pages/QueueAdmin';
import MonitorListAdmin from './pages/MonitorListAdmin';
// import './styles/admin.css';

export default function AppAdmin() {
  return (
    <BrowserRouter basename="/admin">
      <Routes>
        <Route path="/" element={<Navigate to="/queue" replace />} />
        <Route path="/queue" element={<QueueAdmin />} />
        <Route path="/monitor" element={<MonitorListAdmin />} />
        <Route path="*" element={<Navigate to="/queue" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
